import { Redirect, Route, Switch } from "react-router";
import InspectionScheduleForm from "./InspectionScheduleForm";
import InspectionScheduleTable from "./InspectionScheduleTable";
import { useSelector } from "react-redux";

export default () => {
  const { roleId } = useSelector((state) => state.user);
  return (
    <Switch>
      <Route
        exact
        path="/inspection/inspectionscheduling/"
        component={InspectionScheduleTable}
      />
      <Route
        path="/inspection/inspectionscheduling/addnew"
        //component={InspectionScheduleForm}
        render={() =>
          roleId === 4 ? (
            <Redirect to="/inspection/inspectionscheduling" />
          ) : (
            <InspectionScheduleForm />
          )
        }
      />
    </Switch>
  );
};
